import { gql } from "graphql-tag";

export const FETCH_POSTGRES_VIEWER = gql`
  query FetchPostgresViewer {
    viewerPostgres {
      id
      logins {
        username
        method
        verified
        roles
      }
    }
  }
`;
